export default "__VITE_ASSET__CtfoBL5I__"